const BYTES_PER_UNIT = 1024;
const DECIMAL_PRECISION = 10;
const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatBytes(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0 B';
  const unitIndex = Math.min(
    Math.floor(Math.log(value) / Math.log(BYTES_PER_UNIT)),
    BYTE_UNITS.length - 1,
  );
  const scaledValue = value / Math.pow(BYTES_PER_UNIT, unitIndex);
  const roundedValue =
    unitIndex === 0
      ? Math.round(scaledValue)
      : Math.round(scaledValue * DECIMAL_PRECISION) / DECIMAL_PRECISION;
  return `${roundedValue} ${BYTE_UNITS[unitIndex]}`;
}
